import React, { useState } from 'react';
import send from "../../../media/send.svg";
import x from "../../../media/x.svg";
import ThankYoupopupBanner from './ThankyouBanner';

const SubmittedpopupBanner = ({ onClose, where }) => {
  const [name, setName] = useState('');
  const [number, setNumber] = useState('');
  const [showThankYouPopup, setShowThankYouPopup] = useState(false);

  const handleClosePopup = () => {
    onClose();
  };

  const handleFormSubmit = async (e) => {
    e.preventDefault();

    let url = 'https://brich.youthevents.in/Bdashboard/submit-callback-request/';

    try {

      const response = await fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          name,
          number,
        }),
      });

      if (response.status === 201) {
        setShowThankYouPopup(true);
      } else {
      }
    } catch (error) {
    }
  };

  return (
    <div className="popup">
      <div className="popup-content">
        <div onClick={handleClosePopup} className="cross">
          <img src={x} alt="" />
        </div>
        <h2>LETS CONNECT ON CALL</h2>
        <form onSubmit={handleFormSubmit}>
          <div className="custom-input input2">
            <input
              type="text"
              name="name"
              placeholder="Enter Your Full Name"
              value={name}
              onChange={(e) => setName(e.target.value)}
            />
          </div>
          <div className="custom-input input2">
            <input
              type="tel"
              name="number"
              placeholder="Enter Contact No"
              value={number}
              maxLength={10}
              onChange={(e) => setNumber(e.target.value)}
            />
          </div>
          <div
            onClick={handleFormSubmit}
            variant="dark"
            type="submit"
            className="submit-btn send-btn"
          >
            Send <img src={send} alt="" className="send" />
          </div>
        </form>
      </div>
      {showThankYouPopup && <ThankYoupopupBanner onClose={handleClosePopup} />}
    </div>
  );
};

export default SubmittedpopupBanner;
